import { makeAutoObservable } from 'mobx';

// 定义回调函数类型
type Callback = (data: any) => void;

class GlobalStore {
    private callbacks: Record<string, Callback> = {};

    constructor() {
        makeAutoObservable(this);
    }

    // 订阅事件
    subscribe(key: string, callback: Callback): void {
        this.callbacks[key] = callback;
    }

    // 取消订阅事件
    unsubscribe(key: string): void {
        delete this.callbacks[key];
    }

    // 发布事件
    publish(key: string, data: any): void {
        const callback = this.callbacks[key];
        if (callback) {
            callback(data);
        } else {
            console.error(`No callback registered for key: ${key}`);
        }
    }
}

const globalStore = new GlobalStore();
export default globalStore;
